import axios from 'axios';
import PropTypes from 'prop-types';
import { SLACK_MESSAGE_URL } from 'business_logic/constants';

export const postToSlack = async (
  channel = 'olive-messages',
  messageObject,
) => {
  let success = false;
  const channelUrl = () => {
    switch (process.env.NODE_ENV) {
      case 'production':
        return channel;
      case 'development':
        return 'olive-test-message';
    }
  };

  const message = {
    channel: channelUrl(),
    title: messageObject.title,
    message: messageObject.message,
    icon_url:
      messageObject.icon_url || 'https://oasis-living.com/favicon-32x32.png',
  };

  await axios
    .post(SLACK_MESSAGE_URL, message, {
      headers: { 'content-type': 'application/json' },
    })
    .then(rsp => {
      console.log(rsp);
      success = rsp.data.success;
    })
    .catch(error => console.error(error));
  return success;
};

postToSlack.propTypes = {
  channel: PropTypes.string,
  messageObject: PropTypes.objectOf(PropTypes.string).isRequired,
};
